module.exports = __webpack_public_path__ + "img/sys-update-checked.2cf7a983.svg";